module.exports = __webpack_public_path__ + "static/img/pic3.2e653f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intelDevice/pic3.jpg
// module id = v95K
// module chunks = 0